const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const endpoints = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    register: `${API_BASE_URL}/auth/register`,
    logout: `${API_BASE_URL}/auth/logout`,
    accountTypes: `${API_BASE_URL}/auth/account-types`,
    testEmail: `${API_BASE_URL}/auth/test-email`,
    forgotPassword: `${API_BASE_URL}/auth/forgot-password`,
    resetPassword: `${API_BASE_URL}/auth/reset-password`,
    verifyResetToken: (token: string) =>
      `${API_BASE_URL}/auth/verify-reset-token/${token}`,
    resendVerification: `${API_BASE_URL}/auth/resend-verification`,
    verifyEmail: (token: string) =>
      `${API_BASE_URL}/auth/verify-email/${token}`,
    permissions: `${API_BASE_URL}/auth/me/permissions`,
  },
  users: {
    me: `${API_BASE_URL}/users/me`,
    updateMe: `${API_BASE_URL}/users/me`,
    updateCategories: `${API_BASE_URL}/users/me/categories`,
    defaultTemplates: `${API_BASE_URL}/users/me/default-templates`,
  },
  organizations: {
    myOrganization: `${API_BASE_URL}/organizations/me`,
    updateMyOrganization: `${API_BASE_URL}/organizations/me`,
    stats: `${API_BASE_URL}/organizations/me/stats`,
    listMembers: `${API_BASE_URL}/organizations/me/members`,
    removeMember: (memberId: string) =>
      `${API_BASE_URL}/organizations/me/members/${memberId}`,
    leave: `${API_BASE_URL}/organizations/leave-organization`,
    banMember: (memberId: string) =>
      `${API_BASE_URL}/organizations/me/members/${memberId}/ban`,
    unbanMember: (memberId: string) =>
      `${API_BASE_URL}/organizations/me/members/${memberId}/unban`,
    listBannedMembers: `${API_BASE_URL}/organizations/me/banned-members`,
    listInvitations: `${API_BASE_URL}/organizations/me/invitations`,
    createInvitations: `${API_BASE_URL}/organizations/me/invitations`,
    getInvitationDetails: (token: string) =>
      `${API_BASE_URL}/organizations/invitations/${token}`,
    acceptInvitation: (token: string) =>
      `${API_BASE_URL}/organizations/invitations/${token}/accept`,
    declineInvitation: (token: string) =>
      `${API_BASE_URL}/organizations/invitations/${token}/decline`,
    sendWelcomeEmail: `${API_BASE_URL}/organizations/send-welcome-email`,
    uploadCompanyLogo: `${API_BASE_URL}/organizations/me/logo`,
    deleteCompanyLogo: `${API_BASE_URL}/organizations/me/logo`,
  },
  apiKeys: {
    base: `${API_BASE_URL}/api-keys/`,
    deactivate: (keyId: string) => `${API_BASE_URL}/api-keys/${keyId}`,
  },
  promptTemplates: {
    base: `${API_BASE_URL}/prompt-templates/`,
    categories: `${API_BASE_URL}/prompt-templates/categories`,
    details: (templateId: string) =>
      `${API_BASE_URL}/prompt-templates/${templateId}`,
    update: (templateId: string) =>
      `${API_BASE_URL}/prompt-templates/${templateId}`,
    delete: (templateId: string) =>
      `${API_BASE_URL}/prompt-templates/${templateId}`,
    createInterviewConfig: `${API_BASE_URL}/prompt-templates/interview-config`,
    getInterviewConfig: (interviewId: string) =>
      `${API_BASE_URL}/prompt-templates/interview-config/${interviewId}`,
  },
  interviews: {
    base: `${API_BASE_URL}/interviews/`,
    details: (interviewId: string) =>
      `${API_BASE_URL}/interviews/${interviewId}`,
    detailsByApiKey: (interviewId: string) =>
      `${API_BASE_URL}/interviews/api/${interviewId}`,
    result: (interviewId: string) =>
      `${API_BASE_URL}/interviews/${interviewId}/result`,
    update: (interviewId: string) =>
      `${API_BASE_URL}/interviews/${interviewId}`,
    resume: (interviewId: string) =>
      `${API_BASE_URL}/interviews/${interviewId}/resume`,
    token: (interviewId: string) =>
      `${API_BASE_URL}/interviews/${interviewId}/token`,
    joinLink: (interviewId: string) =>
      `${API_BASE_URL}/interviews/${interviewId}/join-link`,
    apiCreate: `${API_BASE_URL}/interviews/api/create`,
    apiToken: (interviewId: string) =>
      `${API_BASE_URL}/interviews/api/${interviewId}/token`,
    searchCandidates: `${API_BASE_URL}/interviews/search/candidates`,
    jobPositionAnalytics: `${API_BASE_URL}/interviews/analytics/job-positions`,
  },
  feedback: {
    submit: `${API_BASE_URL}/feedbacks/`,
    submitMember: `${API_BASE_URL}/feedbacks/member`,
    listForInterview: (interviewId: string) =>
      `${API_BASE_URL}/feedbacks/interview/${interviewId}/with-members`,
    details: (feedbackId: string) => `${API_BASE_URL}/feedbacks/${feedbackId}`,
    update: (feedbackId: string) => `${API_BASE_URL}/feedbacks/${feedbackId}`,
    delete: (feedbackId: string) => `${API_BASE_URL}/feedbacks/${feedbackId}`,
  },
  analytics: {
    interviewGrowth: `${API_BASE_URL}/analytics/interviews/growth`,
    interviewsByStatus: `${API_BASE_URL}/analytics/interviews/by-status`,
    completedSummary: `${API_BASE_URL}/analytics/interviews/completed-summary`,
    topCandidates: `${API_BASE_URL}/analytics/interviews/top-candidates`,
    latestCandidates: `${API_BASE_URL}/analytics/interviews/latest-candidates`,
    permissions: `${API_BASE_URL}/analytics/interviews/permissions`,
    jobPositions: `${API_BASE_URL}/analytics/job-positions`,
  },
  admin: {
    activityLogs: `${API_BASE_URL}/admin/activity-logs/`,
  },
};

export default endpoints;
